import { render, staticRenderFns } from "./Logoscar.vue?vue&type=template&id=4d327299&"
import script from "./Logoscar.vue?vue&type=script&lang=js&"
export * from "./Logoscar.vue?vue&type=script&lang=js&"
import style0 from "./Logoscar.vue?vue&type=style&index=0&id=4d327299&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports